import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import {vfmPlugin} from 'vue-final-modal'

Vue.use(Vuetify)
Vue.use(vfmPlugin)
export default new Vuetify({})
